/* Purely Parsons cart drawer additions: free-shipping bar + data-driven "Pairs well with your order".
   Reads co-purchase counts from #PPCartPairs (shop metafield purely_cart.pairs). */
(function () {
  if (window.__ppCartUpsells) return;
  window.__ppCartUpsells = true;

  var MAX_PICKS = 3;
  var MIN_SHARED = 15;   // ignore pairs seen in fewer orders than this
  var SHOW_WHY_AT = 0.10; // show the "% also bought" line only when it's 10%+

  var data = {};
  try { data = JSON.parse(document.getElementById('PPCartPairs').textContent) || {}; } catch (e) { data = {}; }
  var products = data.products || {};
  // Fixed picks from shop metafield purely_cart.pins: { "<product id>": [["<pinned id>", "<pinned handle>"], ...] }
  var pins = {};
  try { pins = JSON.parse(document.getElementById('PPCartPins').textContent) || {}; } catch (e) { pins = {}; }
  var productCache = {};
  var lastKey = null;
  var busy = false;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function shortName(title) {
    return String(title || '').split(':')[0].replace(/^(Organic|Purely|Pure)\s+/i, '').trim();
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function updateBar(cart) {
    var bar = $('[data-pp-ship]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 7500;
    var subtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    if (!cart.item_count) { bar.hidden = true; return; }
    var left = Math.max(0, threshold - subtotal);
    var pct = Math.min(100, (subtotal / threshold) * 100);
    $('[data-pp-ship-msg]', bar).textContent = left === 0
      ? 'You’ve unlocked free US shipping.'
      : 'You’re ' + money(left) + ' away from free US shipping.';
    $('[data-pp-ship-fill]', bar).style.width = pct + '%';
    bar.classList.toggle('is-done', left === 0);
    bar.hidden = false;
  }

  function pickFor(cart) {
    var inCart = {};
    var anchors = [];
    cart.items.forEach(function (it) {
      var id = String(it.product_id);
      inCart[id] = true;
      if (products[id] && anchors.indexOf(id) === -1) anchors.push(id);
    });
    var best = {};
    anchors.forEach(function (a) {
      var pa = products[a];
      Object.keys(pa.pairs || {}).forEach(function (b) {
        if (inCart[b] || !products[b]) return;
        var shared = pa.pairs[b];
        if (shared < MIN_SHARED) return;
        var rate = shared / pa.n;
        if (!best[b] || rate > best[b].rate) best[b] = { id: b, rate: rate, anchor: a };
      });
    });
    return Object.keys(best).map(function (k) { return best[k]; })
      .sort(function (x, y) { return y.rate - x.rate; });
  }

  // Fixed picks for products in the cart, in cart order, never something already in the cart.
  function pinsFor(cart) {
    var inCart = {}, seen = {}, out = [];
    cart.items.forEach(function (it) { inCart[String(it.product_id)] = true; });
    cart.items.forEach(function (it) {
      var anchor = String(it.product_id);
      (pins[anchor] || []).forEach(function (pn) {
        var id = String(pn[0]);
        if (inCart[id] || seen[id]) return;
        seen[id] = true;
        out.push({ id: id, h: pn[1], rate: 0, anchor: anchor, pinned: true });
      });
    });
    return out;
  }

  function gapFor(cart) {
    var bar = $('[data-pp-ship]');
    if (!bar) return 0; // free-shipping logic only where the bar shows (US)
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 7500;
    var subtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    return Math.max(0, threshold - subtotal);
  }

  function pickVariant(p, c) {
    var pref = products[c.id] ? String(products[c.id].v) : '';
    return (p.variants || []).filter(function (v) { return String(v.id) === pref && v.available; })[0]
      || (p.variants || []).filter(function (v) { return v.available; })[0];
  }

  function render(cart) {
    var box = $('[data-pp-recs]');
    if (!box) return Promise.resolve();
    var list = $('[data-pp-recs-list]', box);
    var pinned = pinsFor(cart);
    var pinnedIds = {};
    pinned.forEach(function (c) { pinnedIds[c.id] = true; });
    var candidates = pickFor(cart).filter(function (c) { return !pinnedIds[c.id]; });
    if (!cart.item_count || (!candidates.length && !pinned.length)) { box.hidden = true; list.innerHTML = ''; return Promise.resolve(); }

    var gap = gapFor(cart);
    // Look up a few extra in case some are sold out or unpublished,
    // plus the best-matching product that would unlock free shipping on its own.
    var pool = pinned.concat(candidates.slice(0, MAX_PICKS + 3));
    if (gap > 0) {
      var closer = candidates.filter(function (c) { return (products[c.id].p || 0) >= gap; })[0];
      if (closer && pool.indexOf(closer) === -1) pool.push(closer);
    }
    var anchorTitles = {};
    cart.items.forEach(function (it) { anchorTitles[String(it.product_id)] = it.product_title; });

    return Promise.all(pool.map(function (c) { return getProduct(c.h || products[c.id].h); })).then(function (infos) {
      var ready = [];
      infos.forEach(function (p, i) {
        if (!p || !p.available) return;
        var variant = pickVariant(p, pool[i]);
        if (variant) ready.push({ c: pool[i], p: p, v: variant, unlocks: gap > 0 && variant.price >= gap });
      });
      // Fixed picks always go in first; data-driven picks fill the rest.
      var chosen = ready.filter(function (r) { return r.c.pinned; }).slice(0, MAX_PICKS);
      ready.forEach(function (r) { if (!r.c.pinned && chosen.length < MAX_PICKS) chosen.push(r); });
      if (gap > 0 && !chosen.some(function (r) { return r.unlocks; })) {
        var bestCloser = ready.filter(function (r) { return r.unlocks && chosen.indexOf(r) === -1; })[0];
        if (bestCloser) {
          var swap = -1;
          chosen.forEach(function (r, i) { if (!r.c.pinned) swap = i; });
          if (chosen.length < MAX_PICKS) chosen.push(bestCloser);
          else if (swap > -1) chosen[swap] = bestCloser;
        }
      }
      // Fixed picks first, then free-shipping picks, then by how often they're bought together.
      chosen.sort(function (a, b) {
        return (b.c.pinned ? 1 : 0) - (a.c.pinned ? 1 : 0) || (b.unlocks ? 1 : 0) - (a.unlocks ? 1 : 0) || b.c.rate - a.c.rate;
      });

      var html = '';
      chosen.forEach(function (r) {
        var p = r.p, c = r.c, variant = r.v;
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
        var why = c.pinned
          ? 'Recommended with your ' + shortName(anchorTitles[c.anchor])
          : (c.rate >= SHOW_WHY_AT
            ? Math.round(c.rate * 100) + '% of ' + shortName(anchorTitles[c.anchor]) + ' buyers also got this'
            : '');
        html += '<div class="pp-rec">' +
          '<span class="pp-rec__tile">' + (img ? '<img class="pp-rec__img" src="' + esc(img) + '" alt="" loading="lazy" width="56" height="56">' : '') + '</span>' +
          '<div class="pp-rec__body">' +
          (r.unlocks ? '<span class="pp-rec__tag">Unlocks free shipping</span>' : '') +
          '<a class="pp-rec__name" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
          (why ? '<span class="pp-rec__why">' + esc(why) + '</span>' : '') +
          '<span class="pp-rec__price">' + money(variant.price) + '</span></div>' +
          '<button type="button" class="pp-rec__add" data-pp-add="' + variant.id + '">ADD</button></div>';
      });
      list.innerHTML = html;
      box.hidden = chosen.length === 0;
    });
  }

  function refresh(force) {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var key = cart.items.map(function (i) { return i.key + ':' + i.quantity; }).join('|') + '@' + cart.items_subtotal_price;
      updateBar(cart);
      if (!force && key === lastKey) return;
      lastKey = key;
      return render(cart);
    }).catch(function () {}).then(function () { busy = false; });
  }

  // Ask the theme to rebuild its drawer after we add something.
  function rebuildDrawer() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pp-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = 'ADDING';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-pp-add')), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      rebuildDrawer();
      setTimeout(function () { refresh(true); }, 400);
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'ADD';
    });
  });

  // The theme re-renders line items inside [data-products]; refresh whenever that changes.
  var drawer = document.getElementById('CartDrawer');
  var productsEl = drawer && drawer.querySelector('[data-products]');
  if (productsEl && window.MutationObserver) {
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { refresh(false); }, 150); })
      .observe(productsEl, { childList: true, subtree: true });
  }
  ['cart:updated', 'ajaxProduct:added', 'cart:open'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(function () { refresh(false); }, 300); });
  });

  refresh(true);
})();
